module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/O5f7vf/tc-custom/9781488061226.jpg?1705015262313",
      "alt": "This image is the cover for the book Amish Sanctuary"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Amish Sanctuary\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A woman on the run. A baby in danger."), _c('br'), _c('br'), _vm._v("Can her Amish ex-fiancé save them?"), _c('br'), _c('br')]), _vm._v("To keep her patient’s baby safe from a killer, counselor Naomi Kemp will do things she never thought possible, like return to her Amish hometown…and her ex-fiancé. Widower Sawyer Zook can offer Naomi and the baby protection and a place to hide. But Sawyer can’t shield Naomi from what threatens her most: the traumatic past that drove her away years ago…\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katy Lee\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Best-selling and award-winning author Katy Lee writes novels filled with romance, suspense and inspiration. She lives in the rugged beauty of the Utah mountains where she is also a special education teacher at a school for international students. Katy loves to knit warm wooly things while plotting her next suspense story. Keep up with Katy at KatyLeeBooks.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0